// F5: mirrors FulfilmentDtos (backend sales/fulfilment/dto)
import { ChallanStatus } from './salesOrder.interface';

export type ShipmentStatus = 'PENDING' | 'SHIPPED' | 'IN_TRANSIT' | 'DELIVERED' | 'RETURNED' | 'CANCELLED';
export const SHIPMENT_STATUSES: ShipmentStatus[] = ['PENDING', 'SHIPPED', 'IN_TRANSIT', 'DELIVERED', 'RETURNED', 'CANCELLED'];

type ChipColor = 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
export const SHIPMENT_STATUS_COLORS: Record<ShipmentStatus, ChipColor> = {
  PENDING: 'default', SHIPPED: 'primary', IN_TRANSIT: 'info', DELIVERED: 'success', RETURNED: 'warning', CANCELLED: 'error',
};

/** The moves the backend allows from each status (the challan-cancelled case is narrowed in the tab). */
export const SHIPMENT_NEXT: Record<ShipmentStatus, ShipmentStatus[]> = {
  PENDING: ['SHIPPED', 'CANCELLED'],
  SHIPPED: ['IN_TRANSIT', 'DELIVERED', 'RETURNED', 'CANCELLED'],
  IN_TRANSIT: ['DELIVERED', 'RETURNED'],
  DELIVERED: ['RETURNED'],
  RETURNED: [],
  CANCELLED: [],
};

export const PACKAGE_TYPE_SUGGESTIONS = ['Carton', 'Bag', 'Pallet', 'Roll', 'Other'];

export interface PackageLineRequest { challanLineId: string; quantity: number }
export interface PackageRequest {
  packageType?: string; grossWeightKg?: number | null; netWeightKg?: number | null;
  lengthCm?: number | null; widthCm?: number | null; heightCm?: number | null; notes?: string; lines: PackageLineRequest[];
}
export interface PackageLine { id: string; challanLineId: string; itemId?: string; itemCode?: string; itemName?: string; unit?: string; quantity: number }
export interface SalesPackage {
  id: string; seq: number; packageType?: string; grossWeightKg?: number; netWeightKg?: number;
  lengthCm?: number; widthCm?: number; heightCm?: number; notes?: string; lines: PackageLine[];
}
export interface PackableLine {
  challanLineId: string; itemId?: string; itemCode?: string; itemName?: string; unit?: string; description?: string;
  challanQty: number; packedQty: number; remainingQty: number; packable: boolean;
}
export interface PackagesView {
  challanId: string; challanNo?: string; challanStatus: ChallanStatus; shipmentStatus?: ShipmentStatus | null;
  editable: boolean; lockReason?: string | null; lines: PackableLine[]; packages: SalesPackage[];
}

export interface ShipmentRequest { carrier?: string; trackingNo?: string; trackingUrl?: string; notes?: string }
export interface ShipmentStatusRequest { status: ShipmentStatus; shippedOn?: string; deliveredOn?: string; deliveredTo?: string }
export interface Shipment {
  id: string; challanId: string; shipmentNo: string; carrier?: string; trackingNo?: string; trackingUrl?: string | null;
  status: ShipmentStatus; shippedOn?: string; deliveredOn?: string; deliveredTo?: string; notes?: string; createdAt?: string;
}
export interface ShipmentView {
  challanId: string; challanNo?: string; challanStatus: ChallanStatus; challanDate: string;
  shipment?: Shipment | null; history: Shipment[];
}
export interface ShipmentRow {
  id: string; shipmentNo: string; challanId: string; challanNo?: string; orderNo?: string; customerName?: string;
  carrier?: string; trackingNo?: string; trackingUrl?: string | null; status: ShipmentStatus;
  shippedOn?: string; deliveredOn?: string; packageCount: number;
}
export interface ShipmentPage { content: ShipmentRow[]; totalElements: number; totalPages: number; number: number; size: number }

/** D-P2-3: only an absolute http(s) URL is ever rendered as a link. */
export const isHttpUrl = (url?: string | null): url is string => !!url && /^https?:\/\/[^\s]+$/i.test(url);

// ---- F7 ----
/** Result of the manual "E-mail customer" click on a shipped shipment. */
export interface ShipmentEmailResult {
  sentTo: string;
  shipmentNo: string;
  customTemplate: boolean;
}
// ---- end F7 ----
